// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as deleteAccountReducer } from './deleteAccount';
import { reducer as getAccountTermsReducer } from './getAccountTerms';
import { reducer as getAccountReducer } from './getAccount';
import { reducer as getAccountBillReducer } from './getAccountBillOverview';
import { reducer as getAccountCampaignPurchasesReducer } from './getAccountCampaignPurchases';
import { reducer as getAccountCardsReducer } from './getAccountCards';
import { reducer as getAccountTransactionsReducer } from './getAccountTransactions';
import { reducer as getAccountsReducer } from './getAccounts';
import { reducer as getAccountPaymentTermsReducer } from './getAccountPaymentTerms';
import { reducer as getAccountLimitRaiseTermsReducer } from './getAccountLimitRaiseTerms';
import { reducer as getPromissoryNotesReducer } from './getPromissoryNotes';
import { reducer as closeAccountReducer } from './closeAccount';
import { reducer as getAccountBillDetailsReducer } from './getAccountBillDetails';

const reducers = [
    deleteAccountReducer,
    getAccountTermsReducer,
    getAccountReducer,
    getAccountBillReducer,
    getAccountCampaignPurchasesReducer,
    getAccountCardsReducer,
    getAccountTransactionsReducer,
    getAccountsReducer,
    getAccountPaymentTermsReducer,
    getAccountLimitRaiseTermsReducer,
    getPromissoryNotesReducer,
    closeAccountReducer,
    getAccountBillDetailsReducer,
];

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
    let nextState;
    switch (action.type) {
        // Handle cross-topic actions here
        case 'CLEAR_STATE':
            nextState = initialState;
            break;
        default:
            nextState = state;
            break;
    }
    return reducers.reduce((s, r) => r(s, action), nextState);
}
